module.exports = __webpack_public_path__ + "img/q-logo.ffc1eee8.png";